import { Modal, Table } from '@bitcine/cinesend-theme/dist'
import { useMutation, useQuery } from '@tanstack/react-query'
import { useState } from 'react'
import axios from 'axios'
import { useQueryClient } from '@tanstack/react-query'
import useTableFilters from '../../hooks/use_table_filters'

const RecallModal = ({ label, onClose, id, currentAssetsQueryKey, recallableAssetsQueryKey }) => {
  const [selectedIDs, setSelectedIDs] = useState([])
  const queryClient = useQueryClient()
  const recallAsset = useMutation(
    () => {
      return axios.post(`/cycles/${id}/recall-asset`, { recalled_assets: selectedIDs })
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(currentAssetsQueryKey)
        onClose()
      },
    }
  )
  const { queryString, searching } = useTableFilters({
    enableSearch: true,
    queryExists: true,
  })
  const { data: recallableAssets, isLoading, error } = useQuery([recallableAssetsQueryKey, queryString])

  return (
    <Modal
      header={`Recall ${label}`}
      onClose={onClose}
      confirmButton={{
        text: 'Recall',
        disabled: selectedIDs.length === 0,
        onClick: () => recallAsset.mutate(),
      }}
    >
      <Table
        widths={['auto']}
        header={{ searching }}
        status={{
          pending: isLoading,
          error: error,
          errorMessage: error?.message,
        }}
        body={{
          data: recallableAssets ?? [],
          row: {
            checkbox: {
              checked: (data) => selectedIDs.includes(data.latest_version_id),
              onChange: (data) =>
                selectedIDs.includes(data.latest_version_id)
                  ? setSelectedIDs(selectedIDs.filter((i) => i !== data.latest_version_id))
                  : setSelectedIDs([...selectedIDs, data.latest_version_id]),
            },
            render: [(data) => data.title],
          },
        }}
      />
    </Modal>
  )
}

export default RecallModal
